export var deg2rad = Math.PI / 180;
export var rad2deg = 180 / Math.PI;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-color@1.4.1@d3-color/src/math.js
// module id = 90
// module chunks = 0